<template>
  <a :href="urlWeb" :class="classContenedora" target="_blank">
    <img id="logo-institucion" :src="getUrlImagen" :style="styleImg" />
  </a>
</template>

<script>
import axios from "axios";
export default {
  name: "LogoIntitucion",
  props: {
    idLogo: { type: Number },
    urlWeb: { type: String },
    classContenedora: { type: String },
    styleImg: { type: String }
  },
  computed: {
    getUrlImagen() {
      if (this.idLogo) {
        return CDN.LOGO_INST + this.idLogo + ".png";
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/generales/iconos/LogoInstitucion.vue